import {
  GetStoreExecutorRequest,
  GetStoreExecutorResponse,
  STORE_GET_FULL,
  STORE_SYNC_URL,
  SyncMapRequest,
  SyncMapResponse,
} from "@project/shared-types";
import apiFetchPost from "./ClientAPI";

export const StoreSyncAPI = async (dataRequest: SyncMapRequest) => {
  try {
    const response = await apiFetchPost<SyncMapRequest, SyncMapResponse>(
      STORE_SYNC_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const StoreGetFullAPI = async (dataRequest: GetStoreExecutorRequest) => {
  try {
    const response = await apiFetchPost<
      GetStoreExecutorRequest,
      GetStoreExecutorResponse
    >(STORE_GET_FULL, dataRequest);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
